import * as React from "react";
import { Image } from "../Image";

const MapMarker = () => (
  <Image
    // Override Image component's overflow=hidden
    overflow="default"
    src="map-marker.svg"
    width="52px"
    height="74px"
    // Ensure positioned from its bottom-center
    $style={{
      transform: "translate(-26px, -58px)",
    }}
  />
);

export { MapMarker };
